import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a10b771"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main_formtemplate" }
const _hoisted_2 = { class: "left_panel" }
const _hoisted_3 = { class: "panel_header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "表单模板", -1))
const _hoisted_5 = { class: "panel_header_btns" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("导出Excel")
const _hoisted_8 = { class: "template_list" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "template_name" }
const _hoisted_11 = { class: "template_principal" }
const _hoisted_12 = { class: "template_actions" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_15 = {
  key: 0,
  class: "no_data"
}
const _hoisted_16 = { class: "right_panel" }
const _hoisted_17 = {
  key: 0,
  class: "step_config"
}
const _hoisted_18 = { class: "panel_header" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("添加流程环节")
const _hoisted_20 = { class: "step_list" }
const _hoisted_21 = { class: "step_card_header" }
const _hoisted_22 = { class: "step_order" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_25 = { class: "step_card_body" }
const _hoisted_26 = { class: "step_info_row" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "流程描述：", -1))
const _hoisted_28 = { class: "step_info_row" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "简述：", -1))
const _hoisted_30 = { class: "step_info_row" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "执行人：", -1))
const _hoisted_32 = { class: "step_info_row" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "审核人：", -1))
const _hoisted_34 = { class: "step_info_row" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "必须上传附件：", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"margin-left":"15px"} }, "设置完成时间：", -1))
const _hoisted_37 = {
  key: 0,
  style: {"margin-left":"15px","color":"#606266"}
}
const _hoisted_38 = { class: "step_info_row" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "执行人签字：", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"margin-left":"15px"} }, "执行人填结论：", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"margin-left":"15px"} }, "审核人签字：", -1))
const _hoisted_42 = {
  key: 0,
  class: "no_data"
}
const _hoisted_43 = {
  key: 1,
  class: "no_select"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"15px"} }, null, -1))
const _hoisted_45 = { class: "flexCenter" }
const _hoisted_46 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_47 = /*#__PURE__*/_createTextVNode("确 定")
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"10px","font-size":"12px","color":"#999"} }, "开启后可上传多个附件", -1))
const _hoisted_49 = { style: {"margin-left":"10px","font-size":"12px","color":"#999"} }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"15px"} }, null, -1))
const _hoisted_51 = { class: "flexCenter" }
const _hoisted_52 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_53 = /*#__PURE__*/_createTextVNode("确 定")

import { ref, onMounted } from 'vue';
	import { ElMessage, ElMessageBox } from 'element-plus';
	import { CirclePlus } from '@element-plus/icons-vue';
	import { requestAllUser } from '@/api/api';
	import {
		reqFormTemplateList,
		reqFormTemplateEdit,
		reqFormTemplateDelete,
		reqFormTemplateStepList,
		reqFormTemplateStepEdit,
		reqFormTemplateStepDelete,
		reqFormTemplateExport
	} from '@/api/formtemplateApi';

	// 所有人员
	
export default /*#__PURE__*/_defineComponent({
  name: 'FormTemplate',
  setup(__props) {

	const allUserList = ref<any[]>([]);
	// 模板列表
	const templateList = ref<any[]>([]);
	// 当前选中的模板
	const currentTemplateId = ref<number>(0);
	const currentTemplateName = ref<string>('');
	// 流程步骤列表
	const stepList = ref<any[]>([]);
	// 导出中状态
	const exporting = ref<boolean>(false);

	// 模板弹窗
	const templateDialogShow = ref(false);
	const templateDialogTitle = ref('新增模板');
	const templateForm = ref<any>({
		id: 0,
		formname: '',
		principal: ''
	});

	// 步骤弹窗
	const stepDialogShow = ref(false);
	const stepDialogTitle = ref('添加流程环节');
	const stepForm = ref<any>({
		id: 0,
		formid: 0,
		steporder: 1,
		stepdesc: '',
		brief: '',
		executor: '',
		reviewer: '',
		needattach: '0',
		needtime: '0',
		// 默认完成时间偏移天数：表单创建时间 + N 天
		timeoffsetdays: 0,
		executorsign: '0',
		executorconclusion: '0',
		reviewersign: '0'
	});

	onMounted(() => {
		loadTemplateList();
		loadAllUser();
	});

	// 加载所有人员
	const loadAllUser = () => {
		requestAllUser().then((res: any) => {
			if (res.status === 1) {
				allUserList.value = res.datalist || [];
			}
		});
	};

	// 加载模板列表
	const loadTemplateList = () => {
		reqFormTemplateList({ pageSize: 100, pageIndex: 1 }).then((res: any) => {
			if (res.code === 0 || res.data) {
				const data = res.data || res.DataMap || [];
				templateList.value = data.map((item: any) => ({
					cell: item.cell || item
				}));
			}
		});
	};

	// 选中模板
	const selectTemplate = (item: any) => {
		currentTemplateId.value = item.cell.id;
		currentTemplateName.value = item.cell.formname;
		loadStepList();
	};

	// 导出所有表单模板为 Excel（每个模板一个 sheet，后端生成文件并下载）
	const exportExcel = () => {
		exporting.value = true;
		reqFormTemplateExport({}).then((res: any) => {
			exporting.value = false;
			if (res.status === 1 && res.datalist) {
				// 后端返回 /imgfile/xxx.xlsx（main.go 已静态映射 /imgfile），拼接同源根路径即可
				const path: string = String(res.datalist);
				const url = path.startsWith('http') ? path : `${window.location.origin}${path}`;
				const ts = new Date().toISOString().slice(0, 19).replace(/[T:]/g, '-');
				const a = document.createElement('a');
				a.href = url;
				a.style.display = 'none';
				a.download = `表单模板_${ts}.xlsx`;
				document.body.appendChild(a);
				a.click();
				document.body.removeChild(a);
				ElMessage({ message: '导出成功，已开始下载', type: 'success', duration: 1000 });
			} else {
				ElMessage({ message: res.msg || '导出失败', type: 'error', duration: 800 });
			}
		}).catch(() => { exporting.value = false });
	};

	// 加载步骤列表
	const loadStepList = () => {
		if (currentTemplateId.value > 0) {
			reqFormTemplateStepList({ formid: currentTemplateId.value }).then((res: any) => {
				if (res.status === 1) {
					stepList.value = res.datalist || [];
				}
			});
		}
	};

	// 新增模板
	const addTemplate = () => {
		templateDialogTitle.value = '新增模板';
		templateForm.value = { id: 0, formname: '', principal: '' };
		templateDialogShow.value = true;
	};

	// 编辑模板
	const editTemplate = (item: any) => {
		templateDialogTitle.value = '编辑模板';
		templateForm.value = {
			id: item.cell.id,
			formname: item.cell.formname,
			principal: item.cell.principal
		};
		templateDialogShow.value = true;
	};

	// 删除模板
	const deleteTemplate = (item: any) => {
		ElMessageBox.confirm('确定要删除该表单模板吗？删除后关联的流程配置也将被清除。', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(() => {
			reqFormTemplateDelete({ id: item.cell.id }).then((res: any) => {
				if (res.status === 1) {
					ElMessage({ message: '删除成功', type: 'success', duration: 500 });
					if (currentTemplateId.value === item.cell.id) {
						currentTemplateId.value = 0;
						currentTemplateName.value = '';
						stepList.value = [];
					}
					loadTemplateList();
				}
			});
		}).catch(() => {});
	};

	// 提交模板
	const submitTemplate = () => {
		if (!templateForm.value.formname) {
			ElMessage.warning('请输入表单名称');
			return;
		}
		reqFormTemplateEdit({
			id: templateForm.value.id,
			formname: templateForm.value.formname,
			principal: templateForm.value.principal
		}).then((res: any) => {
			if (res.status === 1) {
				ElMessage({ message: '操作成功', type: 'success', duration: 500 });
				templateDialogShow.value = false;
				loadTemplateList();
				// 如果是新增，自动选中
				if (templateForm.value.id === 0 && res.datalist) {
					currentTemplateId.value = res.datalist;
					currentTemplateName.value = templateForm.value.formname;
					loadStepList();
				}
			} else {
				ElMessage({ message: res.msg || '操作失败', type: 'error', duration: 500 });
			}
		});
	};

	// 添加步骤
	const addStep = () => {
		stepDialogTitle.value = '添加流程环节';
		stepForm.value = {
			id: 0,
			formid: currentTemplateId.value,
			steporder: stepList.value.length + 1,
			stepdesc: '',
			brief: '',
			executor: '',
			reviewer: '',
			needattach: '0',
			needtime: '0',
			timeoffsetdays: 0,
			executorsign: '0',
			executorconclusion: '0',
			reviewersign: '0'
		};
		stepDialogShow.value = true;
	};

	// 编辑步骤
	const editStep = (step: any, index: number) => {
		stepDialogTitle.value = '编辑流程环节';
		stepForm.value = {
			id: step.id,
			formid: step.formid,
			steporder: step.steporder,
			stepdesc: step.stepdesc,
			brief: step.brief || '',
			executor: step.executor,
			reviewer: step.reviewer,
			needattach: step.needattach || '0',
			needtime: step.needtime || '0',
			timeoffsetdays: parseInt(step.timeoffsetdays) || 0,
			executorsign: step.executorsign || '0',
			executorconclusion: step.executorconclusion || '0',
			reviewersign: step.reviewersign || '0'
		};
		stepDialogShow.value = true;
	};

	// 删除步骤
	const deleteStep = (step: any) => {
		ElMessageBox.confirm('确定要删除该流程环节吗？', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(() => {
			reqFormTemplateStepDelete({ id: step.id }).then((res: any) => {
				if (res.status === 1) {
					ElMessage({ message: '删除成功', type: 'success', duration: 500 });
					loadStepList();
				}
			});
		}).catch(() => {});
	};

	// 提交步骤
	const submitStep = () => {
		if (!stepForm.value.stepdesc) {
			ElMessage.warning('请输入流程描述');
			return;
		}
		reqFormTemplateStepEdit({
			id: stepForm.value.id,
			formid: stepForm.value.formid,
			steporder: stepForm.value.steporder,
			stepdesc: stepForm.value.stepdesc,
			brief: stepForm.value.brief || '',
			executor: stepForm.value.executor,
			reviewer: stepForm.value.reviewer,
			needattach: stepForm.value.needattach,
			needtime: stepForm.value.needtime,
			timeoffsetdays: stepForm.value.timeoffsetdays || 0,
			executorsign: stepForm.value.executorsign,
			executorconclusion: stepForm.value.executorconclusion,
			reviewersign: stepForm.value.reviewersign
		}).then((res: any) => {
			if (res.status === 1) {
				ElMessage({ message: '操作成功', type: 'success', duration: 500 });
				stepDialogShow.value = false;
				loadStepList();
			} else {
				ElMessage({ message: res.msg || '操作失败', type: 'error', duration: 500 });
			}
		});
	};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_switch = _resolveComponent("el-switch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_button, {
            type: "primary",
            size: "small",
            onClick: addTemplate,
            icon: _unref(CirclePlus)
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }, 8, ["icon"]),
          _createVNode(_component_el_button, {
            type: "success",
            size: "small",
            loading: exporting.value,
            onClick: exportExcel
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(templateList.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass(["template_item", {active: currentTemplateId.value === item.cell.id}]),
            onClick: ($event: any) => (selectTemplate(item))
          }, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(item.cell.formname), 1),
            _createElementVNode("div", _hoisted_11, "负责人：" + _toDisplayString(item.cell.principal), 1),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_el_button, {
                type: "primary",
                link: "",
                size: "small",
                onClick: _withModifiers(($event: any) => (editTemplate(item)), ["stop"])
              }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_button, {
                type: "danger",
                link: "",
                size: "small",
                onClick: _withModifiers(($event: any) => (deleteTemplate(item)), ["stop"])
              }, {
                default: _withCtx(() => [
                  _hoisted_14
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ], 10, _hoisted_9))
        }), 128)),
        (templateList.value.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, "暂无数据，请点击新增"))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      (currentTemplateId.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("span", null, _toDisplayString(currentTemplateName.value) + " - 流程配置", 1),
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                onClick: addStep,
                icon: _unref(CirclePlus)
              }, {
                default: _withCtx(() => [
                  _hoisted_19
                ]),
                _: 1
              }, 8, ["icon"])
            ]),
            _createElementVNode("div", _hoisted_20, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stepList.value, (step, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "step_card"
                }, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("span", _hoisted_22, "环节 " + _toDisplayString(index + 1), 1),
                    _createElementVNode("div", null, [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        link: "",
                        size: "small",
                        onClick: ($event: any) => (editStep(step, index))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_23
                        ]),
                        _: 2
                      }, 1032, ["onClick"]),
                      _createVNode(_component_el_button, {
                        type: "danger",
                        link: "",
                        size: "small",
                        onClick: ($event: any) => (deleteStep(step))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_24
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _hoisted_27,
                      _createElementVNode("span", null, _toDisplayString(step.stepdesc), 1)
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _hoisted_29,
                      _createElementVNode("span", null, _toDisplayString(step.brief), 1)
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _hoisted_31,
                      _createElementVNode("span", null, _toDisplayString(step.executor), 1)
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _hoisted_33,
                      _createElementVNode("span", null, _toDisplayString(step.reviewer), 1)
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _hoisted_35,
                      _createElementVNode("span", {
                        class: _normalizeClass(step.needattach==='1'?'yes':'no')
                      }, _toDisplayString(step.needattach==='1'?'是':'否'), 3),
                      _hoisted_36,
                      _createElementVNode("span", {
                        class: _normalizeClass(step.needtime==='1'?'yes':'no')
                      }, _toDisplayString(step.needtime==='1'?'是':'否'), 3),
                      (step.needtime==='1')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_37, "（创建时间 + " + _toDisplayString(parseInt(step.timeoffsetdays)||0) + " 天）", 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _hoisted_39,
                      _createElementVNode("span", {
                        class: _normalizeClass(step.executorsign==='1'?'yes':'no')
                      }, _toDisplayString(step.executorsign==='1'?'是':'否'), 3),
                      _hoisted_40,
                      _createElementVNode("span", {
                        class: _normalizeClass(step.executorconclusion==='1'?'yes':'no')
                      }, _toDisplayString(step.executorconclusion==='1'?'是':'否'), 3),
                      _hoisted_41,
                      _createElementVNode("span", {
                        class: _normalizeClass(step.reviewersign==='1'?'yes':'no')
                      }, _toDisplayString(step.reviewersign==='1'?'是':'否'), 3)
                    ])
                  ])
                ]))
              }), 128)),
              (stepList.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_42, "暂无流程环节，请点击添加"))
                : _createCommentVNode("", true)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_43, "请先选择或新增一个表单模板"))
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: templateDialogShow.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((templateDialogShow).value = $event)),
      title: templateDialogTitle.value,
      "show-close": false,
      "close-on-click-modal": false,
      width: "450px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, { "label-width": "100px" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "表单名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: templateForm.value.formname,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((templateForm.value.formname) = $event)),
                  placeholder: "请输入表单名称"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "总负责人" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: templateForm.value.principal,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((templateForm.value.principal) = $event)),
                  placeholder: "请输入总负责人"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _hoisted_44,
        _createElementVNode("div", _hoisted_45, [
          _createVNode(_component_el_button, {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (templateDialogShow.value = false))
          }, {
            default: _withCtx(() => [
              _hoisted_46
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: submitTemplate
          }, {
            default: _withCtx(() => [
              _hoisted_47
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: stepDialogShow.value,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((stepDialogShow).value = $event)),
      title: stepDialogTitle.value,
      "show-close": false,
      "close-on-click-modal": false,
      width: "600px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, { "label-width": "140px" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "步骤序号" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  modelValue: stepForm.value.steporder,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((stepForm.value.steporder) = $event)),
                  min: 1,
                  max: 99
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "流程描述" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: stepForm.value.stepdesc,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((stepForm.value.stepdesc) = $event)),
                  type: "textarea",
                  autosize: {minRows:2},
                  placeholder: "请输入流程描述"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "简述" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: stepForm.value.brief,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((stepForm.value.brief) = $event)),
                  placeholder: "请输入简述"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "流程执行人" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  filterable: "",
                  modelValue: stepForm.value.executor,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((stepForm.value.executor) = $event)),
                  placeholder: "请选择执行人",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "",
                      value: ""
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allUserList.value, (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item.name,
                        value: item.name,
                        key: index
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "流程审核人" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  filterable: "",
                  modelValue: stepForm.value.reviewer,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((stepForm.value.reviewer) = $event)),
                  placeholder: "请选择审核人",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "",
                      value: ""
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allUserList.value, (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item.name,
                        value: item.name,
                        key: index
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "是否必须上传附件" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_switch, {
                  modelValue: stepForm.value.needattach,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((stepForm.value.needattach) = $event)),
                  "active-value": "1",
                  "inactive-value": "0"
                }, null, 8, ["modelValue"]),
                _hoisted_48
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "是否设置完成时间" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_switch, {
                  modelValue: stepForm.value.needtime,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((stepForm.value.needtime) = $event)),
                  "active-value": "1",
                  "inactive-value": "0"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (stepForm.value.needtime==='1')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "默认完成时间"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input_number, {
                      modelValue: stepForm.value.timeoffsetdays,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((stepForm.value.timeoffsetdays) = $event)),
                      min: 0,
                      max: 365,
                      step: 1,
                      size: "small",
                      style: {"width":"140px"}
                    }, null, 8, ["modelValue"]),
                    _createElementVNode("span", _hoisted_49, "表单创建时间 + " + _toDisplayString(stepForm.value.timeoffsetdays||0) + " 天自动生成，生成后可在环节中修改", 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, { label: "执行人是否需要签字" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_switch, {
                  modelValue: stepForm.value.executorsign,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((stepForm.value.executorsign) = $event)),
                  "active-value": "1",
                  "inactive-value": "0"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "执行人是否需要填结论" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_switch, {
                  modelValue: stepForm.value.executorconclusion,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((stepForm.value.executorconclusion) = $event)),
                  "active-value": "1",
                  "inactive-value": "0"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "审核人是否需要签字" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_switch, {
                  modelValue: stepForm.value.reviewersign,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((stepForm.value.reviewersign) = $event)),
                  "active-value": "1",
                  "inactive-value": "0"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _hoisted_50,
        _createElementVNode("div", _hoisted_51, [
          _createVNode(_component_el_button, {
            onClick: _cache[15] || (_cache[15] = ($event: any) => (stepDialogShow.value = false))
          }, {
            default: _withCtx(() => [
              _hoisted_52
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: submitStep
          }, {
            default: _withCtx(() => [
              _hoisted_53
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}
}

})